const $ = jQuery
const scrollSpeed = 750

const SmoothScrollAnchors = {
	bindEvents: () => {
		/*
		 * Smooth Scroll on Pageload
		 * Smooth scrolling on page load if URL have a hash
		 * Author: Franco Moya - @iamravenous
		 */
		if (window.location.hash) {
			var hash = window.location.hash

			if ($(hash).length) {
				SmoothScrollAnchors.scrollToElement(hash)
			}
		}

		/**
		 * Smooth scrolling to page anchor on click
		 **/
		$("a[href*='#']:not([href='#'])").click(function(e) {
			if (
				location.hostname == this.hostname &&
				this.pathname.replace(/^\//, "") ==
					location.pathname.replace(/^\//, "")
			) {
				var hash = $(this.hash)
				hash = hash.length
					? hash
					: $("[name=" + this.hash.slice(1) + "]")
				if (hash.length) {
					SmoothScrollAnchors.scrollToElement(hash)
				}
			}
		})
	},

	scrollToElement: (hash) => {
		$("html, body").animate(
			{
				scrollTop: $(hash).offset().top,
			},
			scrollSpeed,
			"swing"
		)
	},
}

export default SmoothScrollAnchors
